import AdvancedTooltip from 'components/UI/AdvancedTooltip'
import Salary from 'components/UI/Salary'

const commonStatus = {
  label: 'Status',
  propName: 'assignment',
  type: 'assigmentModeUser',
  mobileOrder: -1,
  rowClassName: 'text-center',
  className: 'text-center',
}

const commonNotes = {
  label: 'Uwagi',
  propName: 'notes',
  type: 'notes',
  rowClassName: 'text-center',
  className: 'text-center width-sm',
}

const commonSalary = {
  label: 'Wynagrodzenie brutto',
  type: 'computed',
  propName: 'not_used',
  rowClassName: 'text-center',
  className: 'text-center',
  fn: (task) => <Salary task={task} />,
}

export const getUserTasksHeaders = (project) => {
  let headers = []

  if ([1, 3].includes(project.type))
    headers.push(
      { label: 'Data', propName: 'date', type: 'date', rowClassName: 'text-center', className: 'text-center width-sm' },
      { label: 'Godziny', propName: 'hours', rowClassName: 'text-center', className: 'text-center' },
      {
        label: 'Ilość godzin',
        propName: 'hoursCount',
        ignoreOnMobile: true,
        rowClassName: 'text-center',
        className: 'text-center width-sm',
      },
      commonSalary,
      { label: 'Lokalizacja', propName: 'localization', rowClassName: 'text-center', className: 'text-center' },
      commonNotes,
      commonStatus
    )
  else if (project.type === 2)
    headers.push(
      {
        label: 'Termin',
        propName: 'date',
        type: 'date',
        rowClassName: 'text-center',
        className: 'text-center width-sm',
      },
      { label: 'Nr punktu', propName: 'pointNumber', rowClassName: 'text-center', className: 'text-center' },
      { label: 'Długość ', propName: 'duration', rowClassName: 'text-center', className: 'text-center' },
      {
        ...commonSalary,
        label: (
          <AdvancedTooltip
            title=""
            hideIcon
            description="Szacunkowe wynagrodzenie - zależne od rzeczywistej liczby pojazdów"
            sx={{ display: 'inline-flex' }}
            iconColor="primary"
          >
            Wynagrodzenie brutto
          </AdvancedTooltip>
        ),
      },
      commonNotes,
      commonStatus
    )

  return headers
}
